import { Modal as MantineModal } from "@mantine/core";

function Dialog({
  title,
  size,
  children,
  onClose,
  className,
  opened,
  radius,
  ...restProps
}) {
  return (
    <MantineModal
      className
      title={title || ""}
      onClose={onClose}
      opened={opened}
      size={size || "sm"}
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 3,
      }}
      centered
      radius={radius || "md"}
      {...restProps}
    >
      {children}
    </MantineModal>
  );
}

export default Dialog;
